// ======================================================================
// File Name       : ArchivementDetail
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Table, Form, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import TableHead, { setSortState } from '../../components/TableHead';
import { getItemBoxName, parseDateForDetail } from '../../utils/index';
import { REPORT_STATUS_TEXT } from '../../constants/ArchivementConstant';
import PaginationCustom from '../Pagination';
import BackButton from '../../components/BackButton';
import { DEFAULT_DATE_FORMAT_DETAIL, DEFAULT_DATE_FROM_TEXT, DEFAULT_DATE_FORMAT_SHORT_DETAIL } from '../../constants/index';
import CustomLink from '../button/CustomLink';

const ArchivementDetail = ({
  userInfo,
  userDetailInfo,
  reportListInfo,
  recordNum,
  getStartEndData,
  startPosition,
  handleSortState,
  onShowDetail,
  dataSort,
  handleMouseLeave,
  handleMouseEnter,
}) => {
  const thead = [
    { title: '添削管理ID', sortBy: 0 },
    { title: 'レポート名', sortBy: null },
    { title: 'ユーザー(提出者)', sortBy: null },
    { title: '添削者', sortBy: null },
    { title: 'ステータス', sortBy: null },
    { title: '提出日', sortBy: 2 },
    { title: '結果返却日', sortBy: 3 },
    { title: '添削結果', sortBy: null },
  ];
  let data = thead;
  if (dataSort) {
    const sortBy = dataSort.reportHistorySortType;
    const sortState = dataSort.ascendingDescendingSort;
    data = setSortState(thead, sortBy, sortState);
  }
  const objectStyle = { 'background-color': 'gray' };
  const reportList =
    reportListInfo &&
    reportListInfo.map((report, index) => {
      const reportSubmitDate = parseDateForDetail(
        report.reportSubmitDate,
        DEFAULT_DATE_FORMAT_SHORT_DETAIL,
      );
      const reportReturnedDate = parseDateForDetail(
        report.reportReturnedDate,
        DEFAULT_DATE_FORMAT_SHORT_DETAIL,
      );
      const submitterUserName =
        userDetailInfo && userDetailInfo.bySecernId[report.submitterUserSecernId]
          ? userDetailInfo.bySecernId[report.submitterUserSecernId].userName
          : '';
      const checkerUserName =
        userDetailInfo && userDetailInfo.bySecernId[report.checkerUserSecernId]
          ? userDetailInfo.bySecernId[report.checkerUserSecernId].userName
          : '';
      return (
        <tr key={index} onMouseEnter={() => handleMouseEnter(index)} onMouseLeave={() => handleMouseLeave()}>
          <td>{report.itemLearningHistoryReportIdAuto}</td>
          <td>{report.reportName}</td>
          <td>{submitterUserName}</td>
          <td>{checkerUserName}</td>
          <td>{getItemBoxName(REPORT_STATUS_TEXT, report.reportStatus)}</td>
          <td>{reportSubmitDate}</td>
          <td>{reportReturnedDate}</td>
          <td className="text-center">
            <CustomLink
              className="text-center link-detail"
              onClick={onShowDetail.bind(this, index)}
              text="詳細を見る"
            />
          </td>
        </tr>
      );
    });

  return (
    <div>
      <Col sm={12} className="margin-10">
        <Form className='form-horizontal'>
          <Form.Group>
            <Col sm={3} as={Form.Label}>
              添削者名
            </Col>
            <Col sm={7} as={Form.Label}>
              ：{userInfo && userInfo.userName}
            </Col>
          </Form.Group>
          <Form.Group>
            <Col sm={3} as={Form.Label}>
              添削レポート件数
            </Col>
            <Col sm={7} as={Form.Label}>
              ：{recordNum}件
            </Col>
          </Form.Group>
        </Form>
      </Col>
      <Col sm={12} className="padding-left-right-clear margin-bottom-20">
        <Col sm={5} className="padding-left-right-clear margin-top-30">{'添削者別実績一覧　詳細'}</Col>
      </Col>
      <Table striped hover>
        <thead>
          <TableHead data={data} handleSortState={handleSortState} />
        </thead>
        <tbody>{reportList}</tbody>
      </Table>
      <Col className="d-flex justify-content-center">
          <PaginationCustom
            recordNum={recordNum}
            handlePageSelect={getStartEndData}
            startPosition={startPosition}
          />
        </Col>
    </div>
  );
};

export default ArchivementDetail;
